import { CDNImage } from 'shared-widget-components/src/components/CDNImage/CDNImage';
import { CarouselImages } from '../../../hooks/useCarouselImageRetriever';

/**
 * SlideImage component
 * this component is responsible for rendering the slide image
 * @param image - the image of the slide
 * @returns SlideImage component
 */

export const SlideImage = ({ image }: { image: CarouselImages }) => {
  if (!image.backgroundImageUrl) {
    // if wine width is undefined, if package width is 500, else width is 1080
    const imageWidth = image.type === 'PRODUCT' ? undefined : image.type === 'PACKAGE' ? 500 : 1080;

    // if wine height is 370, if package height is undefined, else height is 607
    const imageHeight = image.type === 'PRODUCT' ? 370 : image.type === 'PACKAGE' ? undefined : 607;

    return <CDNImage src={image.url} alt={image.alt} fit='crop' imageWidth={imageWidth} imageHeight={imageHeight} mobileWidth={image.type === 'PACKAGE' ? 373 : undefined} mobileHeight={210} />;
  }

  return (
    <div className='relative'>
      <CDNImage src={image.backgroundImageUrl} alt={image.alt} fit='crop' imageHeight={607} imageWidth={1080} mobileHeight={210} />
      <div className='absolute w-[60%] mx-auto inset-0 flex justify-center items-center '>
        <CDNImage src={image.url} alt={image.alt} fit='crop' imageWidth={500} mobileWidth={320} />
      </div>
    </div>
  );
};
